import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { InfoCopy, InfoLink } from '../components/info-link';
import { LoanCard } from './card-lenses';

const Info = (props) => (
  <InfoLink title="Second Mortgage / HELOC" {...props}>
    <InfoCopy>
      A loan extended to you by a lending institution that is in addition to the primary mortgage on
      your home.
    </InfoCopy>
  </InfoLink>
);

const RefiLiens = ({ model, onChange, ...cardProps }) => (
  <Card title="Do you have a second mortgage or HELOC on this property?" info={Info} {...cardProps}>
    <BooleanRadioButtons
      name="refiLiens"
      value={model.get('refiLiens')}
      onChange={onChange.bind(null, 'refiLiens')}
    />
  </Card>
);

RefiLiens.id = 'RefiLiens';

RefiLiens.completed = ({ model }) => model.get('refiLiens') != null;

export default LoanCard(RefiLiens);



// WEBPACK FOOTER //
// ./src/cards/refi-liens.js